import React from "react";

import { Badge } from "@/components/ui/badge";
import { useModalities } from "@/shared/hooks/useModalities";
import { getModalityNameByAbbr } from "@/shared/schemas/modalities";

interface ModalityBadgeProps {
  /** La abreviación de la modalidad (ej: "CT", "MRI") */
  modalityAbbr: string;
  /** El idioma para mostrar el nombre (por defecto español) */
  language?: "en" | "es";
  /** Variante del badge */
  variant?: "default" | "secondary" | "destructive" | "outline";
  /** Clase CSS adicional */
  className?: string;
}

/**
 * Componente Badge que muestra el nombre completo de una modalidad
 * Si no encuentra la modalidad, muestra la abreviación
 */
export function ModalityBadge({
  modalityAbbr,
  language = "es",
  variant = "outline",
  className,
}: ModalityBadgeProps): React.JSX.Element {
  const { data: modalities, isLoading, error } = useModalities();

  if (isLoading) {
    return (
      <Badge variant={variant} className={className}>
        ...
      </Badge>
    );
  }

  if (error) {
    console.warn("Error al cargar modalidades:", error);
    return (
      <Badge variant={variant} className={className}>
        {modalityAbbr}
      </Badge>
    );
  }

  const modalityName = modalities
    ? getModalityNameByAbbr(modalities, modalityAbbr, language)
    : modalityAbbr;

  return (
    <Badge variant={variant} className={className}>
      {modalityName}
    </Badge>
  );
}
